import React from 'react';
import styled from "styled-components";
import Elevator from "@/components/ParallaxSlider/Desktop/Elevator";
import Text from "@/components/common/Text";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";

const Wrapper  = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: center;
    width: 100%;
    height: 100%;
`

const Desc = styled(Text)`
	position: absolute;
	bottom: 0;
	right: 0;
	max-width: ${getCssSizeValue(400)};
	padding-bottom: ${getCssSizeValue(40)};
	padding-bottom: ${getCssSizeValue(40)};
`

const Info = ({ slides=[], current={}, index=0, className='', ...props}) => {
	const desc = getHtmlFromRedactorField(current?.description || '')
	return (
		<Wrapper className={` ${className}`}>
			<Elevator data={slides} current={current} index={index}/>
			<Desc tag="div" color="richBlack" className="typo-strawford typo-strawford-67" dangerouslySetInnerHTML={desc}/>
		</Wrapper>
	);
};

export default Info;
